export default "__VITE_ASSET__BEqrPySi__"